import { useNavigate, useParams } from "react-router-dom";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import MainButton from "../../Buttons/MainButton";
import Input from "../../Inputs/Input";
import Title from "../../Title/Title";
import { fileURL, useFetch, usePOST } from "../../../ApiS";
import { Bounce, toast, ToastContainer } from "react-toastify";
import PasswordInput from "../../Inputs/Passwordinput";
import AddImage from "../../../ApiS/AddImage/AddImage";
import { useEffect, useRef, useState } from "react";
import Selected from "../../Inputs/Selected";
import Loader from "../../Loader";
import { AxiosError } from "axios";

interface Curriculums {
  id: number;
  code: string;
  name_en: string;
  name_ar: string;
  min_pass_mark?: number;
  theoretical_mark: number;
  practical_mark: number;
  assistances_marks: number;
  type: string;
  is_optional: boolean;
}
interface Error {
  id?: string[];
  code?: string[];
  name_en?: string[];
  name_ar?: string[];
  min_pass_mark?: string[];
  theoretical_mark?: string[];
  practical_mark?: string[];
  assistances_marks?: string[];
  type?: string[];
  is_optional?: string[];
  in_program?: string[];
  description_file?: string[];
}

// interface Type {
//   id: number;
//   value: string;
// }

interface CurriculumsData {
  data: Curriculums;
}

const Create_Curce: React.FC = () => {
  const notify = (message: string) => {
    toast.error(message, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });
  };
  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  const enabled = id ? true : false;

  const { data, isLoading } = useFetch(
    `admin/curriculums/${id}`,
    `curriculums/${id}`,
    enabled
  );
  let dataOld = data?.data;
  const [image_1, setImage_1] = useState<any>(dataOld?.description_file);

  useEffect(() => {
    if (dataOld?.description_file) {
      setImage_1(dataOld?.description_file);
    }
  }, [dataOld?.description_file]);

  const [errors, setErrors] = useState<Error>({});

  const onError = (error: AxiosError<{ errors: Error; message: string }>) => {
    toast.dismiss("loading");
    toast.error(error.response?.data?.message);
    setErrors(errors);
  };

  const {
    mutation,
    handleChangeInput,
    handleChangeArrayFiles,
    handleSubmit,
    setFormData,
    formData,
    viewFile,
    setViewFile,
    setViewFiles,
    files,
    viewFiles,
    handleChangeSelect,
  } = usePOST(
    {
      _method: id ? "PUT" : "post",
    },
    () => navigate("/curriculums"),
    (error) => {
      onError(error);
    }
  );

  const toastId = useRef<string | number | null>(null);

  useEffect(() => {
    if (mutation.isLoading && !toast.isActive(toastId.current!)) {
      toastId.current = toast.loading("جاري التحميل...", {
        position: "bottom-left",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
    } else if (!mutation.isLoading && toastId.current && !mutation.isError) {
      toast.update(toastId.current, {
        render: "تم التحميل بنجاح!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      toastId.current = null;
    } else if (mutation.isError) {
      toast.update(toastId.current!, {
        render: id ? "هناك خطأ في عملية التعديل" : "هناك خطأ في عملية الاضافة",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
      toastId.current = null;
    }
  }, [mutation.isLoading, mutation.isError]);

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <Row>
        <Col lg={4} md={4}>
          <Title title={id ? "تعديل  المقررات" : "أنشاء المقررات"} />
        </Col>
      </Row>
      <ToastContainer position="bottom-left" />
      <Row justify={"around"}>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="name"
            name="code"
            onChange={handleChangeInput}
            title="ترميز المقرر"
            placeholder="أدخل ترميز المقرر "
            className="!w-full"
            defaultValue={dataOld?.code}
          />
          {errors?.code &&
            errors?.code.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="name"
            name="name_en"
            onChange={handleChangeInput}
            title="الاسم بالانكليزي"
            placeholder="أدخل الاسم بالانكليزي "
            className="!w-full"
            defaultValue={dataOld?.name_en}
          />
          {errors?.name_en &&
            errors?.name_en.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="name"
            name="name_ar"
            onChange={handleChangeInput}
            title="الاسم بالعربي"
            placeholder="أدخل الاسم بالعربي "
            className="!w-full"
            defaultValue={dataOld?.name_ar}
          />
          {errors?.name_ar &&
            errors?.name_ar.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="number"
            name="min_pass_mark"
            onChange={handleChangeInput}
            title="الجد الادنى لعلامة النجاح"
            placeholder="أدخل  الجد الادنى لعلامة النجاح "
            className="!w-full"
            defaultValue={dataOld?.min_pass_mark}
          />
          {errors?.min_pass_mark &&
            errors?.min_pass_mark.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="number"
            name="theoretical_mark"
            onChange={handleChangeInput}
            title="العلامة النظرية"
            placeholder="العلامة النظرية"
            className="!w-full"
            defaultValue={dataOld?.theoretical_mark}
          />
          {errors?.theoretical_mark &&
            errors?.theoretical_mark.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="number"
            name="practical_mark"
            onChange={handleChangeInput}
            title="العلامة العملية"
            placeholder="العلامة العملية"
            className="!w-full"
            defaultValue={dataOld?.practical_mark}
          />
          {errors?.practical_mark &&
            errors?.practical_mark.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="number"
            name="assistances_marks"
            onChange={handleChangeInput}
            title="علامات المساعدة"
            placeholder="علامات المساعدة"
            className="!w-full"
            defaultValue={dataOld?.assistances_marks}
          />
          {errors?.assistances_marks &&
            errors?.assistances_marks.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Selected
            title="نمط المقرر"
            text="نمط المقرر"
            name="type"
            onChange={(e) =>
              handleChangeSelect({
                value: e.currentTarget.value,
                label: e.currentTarget.name,
              })
            }
          >
            <option value="traditional">traditional</option>
            <option value="automated">automated</option>
          </Selected>
          {errors?.type &&
            errors?.type.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <div className=" border-2 border-Main text-l flex items-center justify-center py-2 rounded-2xl gap-2 !w-[97%]">
            <input
              type="checkbox"
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  is_optional: e.target.checked ? 1 : 0,
                }))
              }
              name="is_optional"
              className="relative w-5 h-5"
              defaultChecked={dataOld?.is_optional}
            />
            <span className="text-xl font-bold text-yellow-700 "> مميز </span>
          </div>
          {errors?.is_optional &&
            errors?.is_optional.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <div className=" border-2 border-Main text-l flex items-center justify-center py-2 rounded-2xl gap-2 !w-[97%]">
            <input
              type="checkbox"
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  in_program: e.target.checked ? 1 : 0,
                }))
              }
              name="in_program"
              className="relative w-5 h-5"
              defaultChecked={dataOld?.in_program}
            />
            <span className="text-xl font-bold text-yellow-700 ">
              {" "}
              في البرنامج{" "}
            </span>
          </div>
          {errors?.in_program &&
            errors?.in_program.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <h1 className="mb-4 text-lg text-Dark font-bold">وصف الملف</h1>

          <AddImage
            type="PDF"
            id="description_file"
            title=" وصف الملف "
            name="description_file"
            onChange={(event) => handleChangeInput(event, "description_file")}
            oldPDF={image_1}
            newPDF={viewFile["description_file"]?.pdf}
            clickDeletePDF={() => {
              setViewFile((prev) => ({
                ...prev,
                description_file: { pdf: "" },
              }));
              setFormData((prev) => ({
                ...prev,
                description_file: "",
              }));
            }}
            clickDeleteOldPDF={() => {
              setImage_1(null);
            }}
          />
          {errors?.description_file &&
            errors?.description_file.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
      </Row>
      <Col
        lg={11}
        md={5}
        sm={11}
        className="flex lg:justify-center max-lg:mx-auto  !mt-4 "
      >
        <MainButton
          onClick={() =>
            handleSubmit(id ? `admin/curriculums/${id}` : "admin/curriculums")
          }
          titlebtn={id ? "تعديل" : "انشاء"}
          className="w-[400px] "
        />
      </Col>
    </>
  );
};

export default Create_Curce;
